
'use client';

import { useState } from 'react';
import { ChevronDown, Wrench } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function Header() {
  const router = useRouter();
  const [selectedDevice, setSelectedDevice] = useState('');
  const [selectedBrand, setSelectedBrand] = useState('');
  const [selectedModel, setSelectedModel] = useState('');
  const [openDropdown, setOpenDropdown] = useState(null);

  const devices = [
    { value: 'PHONE', label: 'Smartphone' },
    { value: 'TABLET', label: 'Tablette' },
    { value: 'LAPTOP', label: 'Ordinateur portable' },
  ];

  const brandsByDevice = {
    PHONE: [
      { value: 'APPLE', label: 'Apple' },
      { value: 'SAMSUNG', label: 'Samsung' },
      { value: 'GOOGLE', label: 'Google' },
      { value: 'XIAOMI', label: 'Xiaomi' },
      { value: 'ONEPLUS', label: 'OnePlus' },
      { value: 'HUAWEI', label: 'Huawei' },
      { value: 'OPPO', label: 'Oppo' },
      { value: 'REALME', label: 'Realme' },
      { value: 'MOTOROLA', label: 'Motorola' },
      { value: 'NOKIA', label: 'Nokia' },
      { value: 'HONOR', label: 'Honor' },
      { value: 'SONY_PHONE', label: 'Sony' },
    ],
    TABLET: [
      { value: 'IPAD', label: 'Apple / iPad' },
      { value: 'SAMSUNG_TABLET', label: 'Samsung' },
      { value: 'HUAWEI_TABLET', label: 'Huawei' },
      { value: 'LENOVO_TABLET', label: 'Lenovo' },
      { value: 'XIAOMI_TABLET', label: 'Xiaomi' },
      { value: 'HONOR_TABLET', label: 'Honor' },
      { value: 'OPPO_TABLET', label: 'Oppo' },
      { value: 'REALME_TABLET', label: 'Realme' },
      { value: 'NOKIA_TABLET', label: 'Nokia' },
      { value: 'TABLET_OTHER', label: 'Autre marque' },
    ],
    LAPTOP: [
      { value: 'APPLE_LAPTOP', label: 'Apple' },
      { value: 'DELL', label: 'Dell' },
      { value: 'HP', label: 'HP' },
      { value: 'LENOVO', label: 'Lenovo' },
      { value: 'ASUS', label: 'Asus' },
      { value: 'ACER', label: 'Acer' },
      { value: 'MSI', label: 'MSI' },
      { value: 'RAZER', label: 'Razer' },
      { value: 'MICROSOFT_LAPTOP', label: 'Microsoft' },
    ],
  };

  const modelsByBrand = {
    APPLE: [
      { value: 'IPHONE_17_PRO_MAX', label: 'iPhone 17 Pro Max' },
      { value: 'IPHONE_17_PRO', label: 'iPhone 17 Pro' },
      { value: 'IPHONE_17', label: 'iPhone 17' },
      { value: 'IPHONE_16_PRO_MAX', label: 'iPhone 16 Pro Max' },
      { value: 'IPHONE_16_PRO', label: 'iPhone 16 Pro' },
      { value: 'IPHONE_16E', label: 'iPhone 16e' },
      { value: 'IPHONE_16_PLUS', label: 'iPhone 16 Plus' },
      { value: 'IPHONE_16', label: 'iPhone 16' },
      { value: 'IPHONE_15_PRO_MAX', label: 'iPhone 15 Pro Max' },
      { value: 'IPHONE_15_PRO', label: 'iPhone 15 Pro' },
      { value: 'IPHONE_15_PLUS', label: 'iPhone 15 Plus' },
      { value: 'IPHONE_15', label: 'iPhone 15' },
      { value: 'IPHONE_14_PRO_MAX', label: 'iPhone 14 Pro Max' },
      { value: 'IPHONE_14_PRO', label: 'iPhone 14 Pro' },
      { value: 'IPHONE_14_PLUS', label: 'iPhone 14 Plus' },
      { value: 'IPHONE_14', label: 'iPhone 14' },
      { value: 'IPHONE_13_PRO_MAX', label: 'iPhone 13 Pro Max' },
      { value: 'IPHONE_13_PRO', label: 'iPhone 13 Pro' },
      { value: 'IPHONE_13', label: 'iPhone 13' },
      { value: 'IPHONE_13_MINI', label: 'iPhone 13 Mini' },
      { value: 'IPHONE_12_PRO_MAX', label: 'iPhone 12 Pro Max' },
      { value: 'IPHONE_12_PRO', label: 'iPhone 12 Pro' },
      { value: 'IPHONE_12', label: 'iPhone 12' },
      { value: 'IPHONE_12_MINI', label: 'iPhone 12 Mini' },
      { value: 'IPHONE_11_PRO_MAX', label: 'iPhone 11 Pro Max' },
      { value: 'IPHONE_11_PRO', label: 'iPhone 11 Pro' },
      { value: 'IPHONE_11', label: 'iPhone 11' },
      { value: 'IPHONE_SE_2022', label: 'iPhone SE (2022)' },
      { value: 'IPHONE_SE_2020', label: 'iPhone SE (2020)' },
      { value: 'IPHONE_SE_2016', label: 'iPhone SE (2016)' },
      { value: 'IPHONE_XR', label: 'iPhone XR' },
      { value: 'IPHONE_XS_MAX', label: 'iPhone XS Max' },
      { value: 'IPHONE_XS', label: 'iPhone XS' },
      { value: 'IPHONE_X', label: 'iPhone X' },
      { value: 'IPHONE_8_PLUS', label: 'iPhone 8 Plus' },
      { value: 'IPHONE_8', label: 'iPhone 8' },
      { value: 'IPHONE_7_PLUS', label: 'iPhone 7 Plus' },
      { value: 'IPHONE_7', label: 'iPhone 7' },
      { value: 'IPHONE_6S_PLUS', label: 'iPhone 6s Plus' },
      { value: 'IPHONE_6S', label: 'iPhone 6s' },
      { value: 'IPHONE_6_PLUS', label: 'iPhone 6 Plus' },
      { value: 'IPHONE_6', label: 'iPhone 6' },
      { value: 'IPHONE_UNKNOWN', label: 'Autre iPhone' },
    ],
    APPLE_LAPTOP: [
      { value: 'MACBOOK_PRO_16_M3', label: 'MacBook Pro 16" M3' },
      { value: 'MACBOOK_PRO_14_M3', label: 'MacBook Pro 14" M3' },
      { value: 'MACBOOK_AIR_M2', label: 'MacBook Air M2' },
      { value: 'MACBOOK_AIR_M1', label: 'MacBook Air M1' },
      { value: 'MACBOOK_PRO_16_M2', label: 'MacBook Pro 16" M2' },
      { value: 'MACBOOK_PRO_14_M2', label: 'MacBook Pro 14" M2' },
      { value: 'MACBOOK_PRO_13_M1', label: 'MacBook Pro 13" M1' },
      { value: 'MACBOOK_PRO_16_2019', label: 'MacBook Pro 16" (2019)' },
      { value: 'MACBOOK_PRO_15_2019', label: 'MacBook Pro 15" (2019)' },
      { value: 'MACBOOK_PRO_13_2020', label: 'MacBook Pro 13" (2020)' },
      { value: 'MACBOOK_AIR_2020', label: 'MacBook Air (2020)' },
      { value: 'MACBOOK_AIR_2018', label: 'MacBook Air (2018)' },
      { value: 'MACBOOK_UNKNOWN', label: 'Autre MacBook' },
    ],
    SAMSUNG: [
      { value: 'S24_ULTRA', label: 'Galaxy S24 Ultra' },
      { value: 'S24_PLUS', label: 'Galaxy S24+' },
      { value: 'S24', label: 'Galaxy S24' },
      { value: 'S23_FE', label: 'Galaxy S23 FE' },
      { value: 'S23_ULTRA', label: 'Galaxy S23 Ultra' },
      { value: 'S23_PLUS', label: 'Galaxy S23+' },
      { value: 'S23', label: 'Galaxy S23' },
      { value: 'S22_ULTRA', label: 'Galaxy S22 Ultra' },
      { value: 'S22_PLUS', label: 'Galaxy S22+' },
      { value: 'S22', label: 'Galaxy S22' },
      { value: 'S21_FE', label: 'Galaxy S21 FE' },
      { value: 'S21_ULTRA', label: 'Galaxy S21 Ultra' },
      { value: 'S21_PLUS', label: 'Galaxy S21+' },
      { value: 'S21', label: 'Galaxy S21' },
      { value: 'S20_FE', label: 'Galaxy S20 FE' },
      { value: 'S20_ULTRA', label: 'Galaxy S20 Ultra' },
      { value: 'S20_PLUS', label: 'Galaxy S20+' },
      { value: 'S20', label: 'Galaxy S20' },
      { value: 'S10_PLUS', label: 'Galaxy S10+' },
      { value: 'S10', label: 'Galaxy S10' },
      { value: 'S10E', label: 'Galaxy S10e' },
      { value: 'S9_PLUS', label: 'Galaxy S9+' },
      { value: 'S9', label: 'Galaxy S9' },
      { value: 'S8_PLUS', label: 'Galaxy S8+' },
      { value: 'S8', label: 'Galaxy S8' },
      { value: 'S7_EDGE', label: 'Galaxy S7 Edge' },
      { value: 'S7', label: 'Galaxy S7' },
      { value: 'Z_FOLD_6', label: 'Galaxy Z Fold 6' },
      { value: 'Z_FOLD_5', label: 'Galaxy Z Fold 5' },
      { value: 'Z_FOLD_4', label: 'Galaxy Z Fold 4' },
      { value: 'Z_FOLD_3', label: 'Galaxy Z Fold 3' },
      { value: 'Z_FLIP_6', label: 'Galaxy Z Flip 6' },
      { value: 'Z_FLIP_5', label: 'Galaxy Z Flip 5' },
      { value: 'Z_FLIP_4', label: 'Galaxy Z Flip 4' },
      { value: 'Z_FLIP_3', label: 'Galaxy Z Flip 3' },
      { value: 'A55', label: 'Galaxy A55' },
      { value: 'A54', label: 'Galaxy A54' },
      { value: 'A53', label: 'Galaxy A53' },
      { value: 'A52', label: 'Galaxy A52' },
      { value: 'A51', label: 'Galaxy A51' },
      { value: 'A50', label: 'Galaxy A50' },
      { value: 'A35', label: 'Galaxy A35' },
      { value: 'A34', label: 'Galaxy A34' },
      { value: 'A33', label: 'Galaxy A33' },
      { value: 'A32', label: 'Galaxy A32' },
      { value: 'A25', label: 'Galaxy A25' },
      { value: 'A24', label: 'Galaxy A24' },
      { value: 'A23', label: 'Galaxy A23' },
      { value: 'A22', label: 'Galaxy A22' },
      { value: 'A21', label: 'Galaxy A21' },
      { value: 'A15', label: 'Galaxy A15' },
      { value: 'A14', label: 'Galaxy A14' },
      { value: 'A13', label: 'Galaxy A13' },
      { value: 'A12', label: 'Galaxy A12' },
      { value: 'A10', label: 'Galaxy A10' },
      { value: 'M55', label: 'Galaxy M55' },
      { value: 'M35', label: 'Galaxy M35' },
      { value: 'M34', label: 'Galaxy M34' },
      { value: 'M33', label: 'Galaxy M33' },
      { value: 'NOTE_20_ULTRA', label: 'Galaxy Note 20 Ultra' },
      { value: 'NOTE_20', label: 'Galaxy Note 20' },
      { value: 'NOTE_10_PLUS', label: 'Galaxy Note 10+' },
      { value: 'NOTE_10', label: 'Galaxy Note 10' },
      { value: 'NOTE_9', label: 'Galaxy Note 9' },
      { value: 'NOTE_8', label: 'Galaxy Note 8' },
      { value: 'SAMSUNG_UNKNOWN', label: 'Autre Samsung' },
    ],
    GOOGLE: [
      { value: 'PIXEL_9_PRO_XL', label: 'Pixel 9 Pro XL' },
      { value: 'PIXEL_9_PRO', label: 'Pixel 9 Pro' },
      { value: 'PIXEL_9', label: 'Pixel 9' },
      { value: 'PIXEL_8_PRO', label: 'Pixel 8 Pro' },
      { value: 'PIXEL_8', label: 'Pixel 8' },
      { value: 'PIXEL_8A', label: 'Pixel 8a' },
      { value: 'PIXEL_7_PRO', label: 'Pixel 7 Pro' },
      { value: 'PIXEL_7', label: 'Pixel 7' },
      { value: 'PIXEL_7A', label: 'Pixel 7a' },
      { value: 'PIXEL_6_PRO', label: 'Pixel 6 Pro' },
      { value: 'PIXEL_6', label: 'Pixel 6' },
      { value: 'PIXEL_6A', label: 'Pixel 6a' },
      { value: 'PIXEL_5', label: 'Pixel 5' },
      { value: 'PIXEL_5A', label: 'Pixel 5a' },
      { value: 'PIXEL_4A', label: 'Pixel 4a' },
      { value: 'PIXEL_4', label: 'Pixel 4' },
      { value: 'PIXEL_3A', label: 'Pixel 3a' },
      { value: 'PIXEL_3', label: 'Pixel 3' },
      { value: 'GOOGLE_UNKNOWN', label: 'Autre Pixel' },
    ],
    XIAOMI: [
      { value: 'XIAOMI_14_ULTRA', label: 'Xiaomi 14 Ultra' },
      { value: 'XIAOMI_14_PRO', label: 'Xiaomi 14 Pro' },
      { value: 'XIAOMI_14', label: 'Xiaomi 14' },
      { value: 'XIAOMI_13_ULTRA', label: 'Xiaomi 13 Ultra' },
      { value: 'XIAOMI_13_PRO', label: 'Xiaomi 13 Pro' },
      { value: 'XIAOMI_13', label: 'Xiaomi 13' },
      { value: 'XIAOMI_12_PRO', label: 'Xiaomi 12 Pro' },
      { value: 'XIAOMI_12', label: 'Xiaomi 12' },
      { value: 'REDMI_NOTE_13_PRO', label: 'Redmi Note 13 Pro' },
      { value: 'REDMI_NOTE_13', label: 'Redmi Note 13' },
      { value: 'REDMI_NOTE_12_PRO', label: 'Redmi Note 12 Pro' },
      { value: 'REDMI_NOTE_12', label: 'Redmi Note 12' },
      { value: 'REDMI_12', label: 'Redmi 12' },
      { value: 'POCO_X6_PRO', label: 'Poco X6 Pro' },
      { value: 'POCO_X6', label: 'Poco X6' },
      { value: 'POCO_F5', label: 'Poco F5' },
      { value: 'POCO_F4', label: 'Poco F4' },
      { value: 'POCO_X5_PRO', label: 'Poco X5 Pro' },
      { value: 'XIAOMI_UNKNOWN', label: 'Autre Xiaomi / Redmi / Poco' },
    ],
    ONEPLUS: [
      { value: 'ONEPLUS_12', label: 'OnePlus 12' },
      { value: 'ONEPLUS_11', label: 'OnePlus 11' },
      { value: 'ONEPLUS_10_PRO', label: 'OnePlus 10 Pro' },
      { value: 'ONEPLUS_10T', label: 'OnePlus 10T' },
      { value: 'ONEPLUS_9_PRO', label: 'OnePlus 9 Pro' },
      { value: 'ONEPLUS_9', label: 'OnePlus 9' },
      { value: 'ONEPLUS_8_PRO', label: 'OnePlus 8 Pro' },
      { value: 'ONEPLUS_8', label: 'OnePlus 8' },
      { value: 'ONEPLUS_7T_PRO', label: 'OnePlus 7T Pro' },
      { value: 'ONEPLUS_7T', label: 'OnePlus 7T' },
      { value: 'ONEPLUS_7_PRO', label: 'OnePlus 7 Pro' },
      { value: 'ONEPLUS_7', label: 'OnePlus 7' },
      { value: 'ONEPLUS_NORD_3', label: 'OnePlus Nord 3' },
      { value: 'ONEPLUS_NORD_CE_3', label: 'OnePlus Nord CE 3' },
      { value: 'ONEPLUS_NORD_2T', label: 'OnePlus Nord 2T' },
      { value: 'ONEPLUS_NORD_2', label: 'OnePlus Nord 2' },
      { value: 'ONEPLUS_NORD', label: 'OnePlus Nord' },
      { value: 'ONEPLUS_UNKNOWN', label: 'Autre OnePlus' },
    ],
    HUAWEI: [
      { value: 'P60_PRO', label: 'P60 Pro' },
      { value: 'P60', label: 'P60' },
      { value: 'P50_PRO', label: 'P50 Pro' },
      { value: 'P50', label: 'P50' },
      { value: 'P40_PRO', label: 'P40 Pro' },
      { value: 'P40', label: 'P40' },
      { value: 'P30_PRO', label: 'P30 Pro' },
      { value: 'P30', label: 'P30' },
      { value: 'P20_PRO', label: 'P20 Pro' },
      { value: 'P20', label: 'P20' },
      { value: 'MATE_60_PRO', label: 'Mate 60 Pro' },
      { value: 'MATE_50_PRO', label: 'Mate 50 Pro' },
      { value: 'MATE_40_PRO', label: 'Mate 40 Pro' },
      { value: 'MATE_30_PRO', label: 'Mate 30 Pro' },
      { value: 'MATE_20_PRO', label: 'Mate 20 Pro' },
      { value: 'NOVA_11_PRO', label: 'Nova 11 Pro' },
      { value: 'NOVA_11', label: 'Nova 11' },
      { value: 'NOVA_9', label: 'Nova 9' },
      { value: 'NOVA_5T', label: 'Nova 5T' },
      { value: 'HUAWEI_UNKNOWN', label: 'Autre Huawei' },
    ],
    OPPO: [
      { value: 'FIND_X7_ULTRA', label: 'Find X7 Ultra' },
      { value: 'FIND_X7', label: 'Find X7' },
      { value: 'FIND_X6_PRO', label: 'Find X6 Pro' },
      { value: 'FIND_X5_PRO', label: 'Find X5 Pro' },
      { value: 'FIND_X3_PRO', label: 'Find X3 Pro' },
      { value: 'RENO_12_PRO', label: 'Reno 12 Pro' },
      { value: 'RENO_11_PRO', label: 'Reno 11 Pro' },
      { value: 'RENO_11', label: 'Reno 11' },
      { value: 'RENO_10_PRO', label: 'Reno 10 Pro' },
      { value: 'RENO_10', label: 'Reno 10' },
      { value: 'RENO_8_PRO', label: 'Reno 8 Pro' },
      { value: 'RENO_7', label: 'Reno 7' },
      { value: 'A98', label: 'A98' },
      { value: 'A78', label: 'A78' },
      { value: 'A57', label: 'A57' },
      { value: 'OPPO_UNKNOWN', label: 'Autre Oppo' },
    ],
    REALME: [
      { value: 'GT5_PRO', label: 'GT5 Pro' },
      { value: 'GT5', label: 'GT5' },
      { value: 'GT3', label: 'GT3' },
      { value: 'GT2_PRO', label: 'GT2 Pro' },
      { value: 'REALME_12_PRO_PLUS', label: 'Realme 12 Pro+' },
      { value: 'REALME_12_PRO', label: 'Realme 12 Pro' },
      { value: 'REALME_11_PRO_PLUS', label: 'Realme 11 Pro+' },
      { value: 'REALME_11_PRO', label: 'Realme 11 Pro' },
      { value: 'REALME_10_PRO', label: 'Realme 10 Pro' },
      { value: 'REALME_9_PRO', label: 'Realme 9 Pro' },
      { value: 'REALME_8_PRO', label: 'Realme 8 Pro' },
      { value: 'C55', label: 'C55' },
      { value: 'C53', label: 'C53' },
      { value: 'C35', label: 'C35' },
      { value: 'C33', label: 'C33' },
      { value: 'REALME_UNKNOWN', label: 'Autre Realme' },
    ],
    MOTOROLA: [
      { value: 'EDGE_50_PRO', label: 'Edge 50 Pro' },
      { value: 'EDGE_40_PRO', label: 'Edge 40 Pro' },
      { value: 'EDGE_40', label: 'Edge 40' },
      { value: 'EDGE_30_ULTRA', label: 'Edge 30 Ultra' },
      { value: 'EDGE_30_PRO', label: 'Edge 30 Pro' },
      { value: 'EDGE_30', label: 'Edge 30' },
      { value: 'EDGE_20_PRO', label: 'Edge 20 Pro' },
      { value: 'MOTO_G84', label: 'Moto G84' },
      { value: 'MOTO_G73', label: 'Moto G73' },
      { value: 'MOTO_G54', label: 'Moto G54' },
      { value: 'MOTO_G53', label: 'Moto G53' },
      { value: 'MOTO_G42', label: 'Moto G42' },
      { value: 'MOTO_G32', label: 'Moto G32' },
      { value: 'MOTO_G22', label: 'Moto G22' },
      { value: 'MOTO_G14', label: 'Moto G14' },
      { value: 'MOTO_E13', label: 'Moto E13' },
      { value: 'MOTOROLA_UNKNOWN', label: 'Autre Motorola' },
    ],
    NOKIA: [
      { value: 'NOKIA_G60', label: 'Nokia G60 5G' },
      { value: 'NOKIA_X30', label: 'Nokia X30 5G' },
      { value: 'NOKIA_G42', label: 'Nokia G42 5G' },
      { value: 'NOKIA_G22', label: 'Nokia G22' },
      { value: 'NOKIA_G21', label: 'Nokia G21' },
      { value: 'NOKIA_G20', label: 'Nokia G20' },
      { value: 'NOKIA_G10', label: 'Nokia G10' },
      { value: 'NOKIA_C32', label: 'Nokia C32' },
      { value: 'NOKIA_C12', label: 'Nokia C12' },
      { value: 'NOKIA_5_4', label: 'Nokia 5.4' },
      { value: 'NOKIA_3_4', label: 'Nokia 3.4' },
      { value: 'NOKIA_UNKNOWN', label: 'Autre Nokia' },
    ],
    HONOR: [
      { value: 'MAGIC_6_PRO', label: 'Magic 6 Pro' },
      { value: 'MAGIC_6', label: 'Magic 6' },
      { value: 'MAGIC_5_PRO', label: 'Magic 5 Pro' },
      { value: 'MAGIC_5', label: 'Magic 5' },
      { value: 'MAGIC_4_PRO', label: 'Magic 4 Pro' },
      { value: 'HONOR_90', label: 'Honor 90' },
      { value: 'HONOR_70', label: 'Honor 70' },
      { value: 'HONOR_50', label: 'Honor 50' },
      { value: 'HONOR_X9A', label: 'Honor X9a' },
      { value: 'HONOR_X8A', label: 'Honor X8a' },
      { value: 'HONOR_X7A', label: 'Honor X7a' },
      { value: 'HONOR_X6', label: 'Honor X6' },
      { value: 'HONOR_UNKNOWN', label: 'Autre Honor' },
    ],
    SONY_PHONE: [
      { value: 'XPERIA_1_V', label: 'Xperia 1 V' },
      { value: 'XPERIA_5_V', label: 'Xperia 5 V' },
      { value: 'XPERIA_10_V', label: 'Xperia 10 V' },
      { value: 'XPERIA_1_IV', label: 'Xperia 1 IV' },
      { value: 'XPERIA_5_IV', label: 'Xperia 5 IV' },
      { value: 'XPERIA_10_IV', label: 'Xperia 10 IV' },
      { value: 'XPERIA_1_III', label: 'Xperia 1 III' },
      { value: 'XPERIA_5_III', label: 'Xperia 5 III' },
      { value: 'XPERIA_10_III', label: 'Xperia 10 III' },
      { value: 'SONY_UNKNOWN', label: 'Autre Sony Xperia' },
    ],
    IPAD: [
      { value: 'IPAD_PRO_12_9_2024', label: 'iPad Pro 12.9" (2024)' },
      { value: 'IPAD_PRO_11_2024', label: 'iPad Pro 11" (2024)' },
      { value: 'IPAD_AIR_2024', label: 'iPad Air (2024)' },
      { value: 'IPAD_PRO_12_9_2022', label: 'iPad Pro 12.9" (2022)' },
      { value: 'IPAD_PRO_11_2022', label: 'iPad Pro 11" (2022)' },
      { value: 'IPAD_AIR_2022', label: 'iPad Air (2022)' },
      { value: 'IPAD_10', label: 'iPad 10' },
      { value: 'IPAD_9', label: 'iPad 9' },
      { value: 'IPAD_8', label: 'iPad 8' },
      { value: 'IPAD_7', label: 'iPad 7' },
      { value: 'IPAD_MINI_6', label: 'iPad Mini 6' },
      { value: 'IPAD_MINI_5', label: 'iPad Mini 5' },
      { value: 'IPAD_PRO_12_9_2021', label: 'iPad Pro 12.9" (2021)' },
      { value: 'IPAD_PRO_11_2021', label: 'iPad Pro 11" (2021)' },
      { value: 'IPAD_PRO_12_9_2020', label: 'iPad Pro 12.9" (2020)' },
      { value: 'IPAD_PRO_11_2020', label: 'iPad Pro 11" (2020)' },
      { value: 'IPAD_AIR_2020', label: 'iPad Air (2020)' },
      { value: 'IPAD_AIR_2019', label: 'iPad Air (2019)' },
      { value: 'IPAD_UNKNOWN', label: 'Autre iPad' },
    ],
    SAMSUNG_TABLET: [
      { value: 'TAB_S9_ULTRA', label: 'Galaxy Tab S9 Ultra' },
      { value: 'TAB_S9_PLUS', label: 'Galaxy Tab S9+' },
      { value: 'TAB_S9', label: 'Galaxy Tab S9' },
      { value: 'TAB_S9_FE_PLUS', label: 'Galaxy Tab S9 FE+' },
      { value: 'TAB_S9_FE', label: 'Galaxy Tab S9 FE' },
      { value: 'TAB_S8_ULTRA', label: 'Galaxy Tab S8 Ultra' },
      { value: 'TAB_S8_PLUS', label: 'Galaxy Tab S8+' },
      { value: 'TAB_S8', label: 'Galaxy Tab S8' },
      { value: 'TAB_S7_FE', label: 'Galaxy Tab S7 FE' },
      { value: 'TAB_S7_PLUS', label: 'Galaxy Tab S7+' },
      { value: 'TAB_S7', label: 'Galaxy Tab S7' },
      { value: 'TAB_S6_LITE_2024', label: 'Galaxy Tab S6 Lite (2024)' },
      { value: 'TAB_S6_LITE', label: 'Galaxy Tab S6 Lite' },
      { value: 'TAB_S6', label: 'Galaxy Tab S6' },
      { value: 'TAB_A9_PLUS', label: 'Galaxy Tab A9+' },
      { value: 'TAB_A9', label: 'Galaxy Tab A9' },
      { value: 'TAB_A8', label: 'Galaxy Tab A8' },
      { value: 'TAB_A7_LITE', label: 'Galaxy Tab A7 Lite' },
      { value: 'TAB_A7', label: 'Galaxy Tab A7' },
      { value: 'TAB_ACTIVE_5', label: 'Galaxy Tab Active 5' },
      { value: 'TAB_ACTIVE_4_PRO', label: 'Galaxy Tab Active 4 Pro' },
      { value: 'SAMSUNG_TABLET_UNKNOWN', label: 'Autre Samsung Tab' },
    ],
    HUAWEI_TABLET: [
      { value: 'MATEPAD_PRO_13_2', label: 'MatePad Pro 13.2"' },
      { value: 'MATEPAD_PRO_12_6', label: 'MatePad Pro 12.6"' },
      { value: 'MATEPAD_PRO_11', label: 'MatePad Pro 11"' },
      { value: 'MATEPAD_11_5', label: 'MatePad 11.5"' },
      { value: 'MATEPAD_11', label: 'MatePad 11"' },
      { value: 'MATEPAD_SE_11', label: 'MatePad SE 11"' },
      { value: 'MATEPAD_SE_10_4', label: 'MatePad SE 10.4"' },
      { value: 'MATEPAD_10_4', label: 'MatePad 10.4"' },
      { value: 'MATEPAD_T10S', label: 'MatePad T10s' },
      { value: 'MATEPAD_T10', label: 'MatePad T10' },
      { value: 'MATEPAD_T8', label: 'MatePad T8' },
      { value: 'HUAWEI_TABLET_UNKNOWN', label: 'Autre Huawei MatePad' },
    ],
    LENOVO_TABLET: [
      { value: 'TAB_EXTREME', label: 'Tab Extreme' },
      { value: 'TAB_P12_PRO', label: 'Tab P12 Pro' },
      { value: 'TAB_P11_PRO_GEN2', label: 'Tab P11 Pro Gen 2' },
      { value: 'TAB_P11_PLUS', label: 'Tab P11 Plus' },
      { value: 'TAB_P11', label: 'Tab P11' },
      { value: 'TAB_M11', label: 'Tab M11' },
      { value: 'TAB_M10_PLUS', label: 'Tab M10 Plus' },
      { value: 'TAB_M10', label: 'Tab M10' },
      { value: 'TAB_M9', label: 'Tab M9' },
      { value: 'TAB_M8', label: 'Tab M8' },
      { value: 'YOGA_TAB_13', label: 'Yoga Tab 13' },
      { value: 'YOGA_TAB_11', label: 'Yoga Tab 11' },
      { value: 'LENOVO_TABLET_UNKNOWN', label: 'Autre Lenovo Tab' },
    ],
    XIAOMI_TABLET: [
      { value: 'PAD_6S_PRO', label: 'Pad 6S Pro' },
      { value: 'PAD_6_MAX', label: 'Pad 6 Max' },
      { value: 'PAD_6_PRO', label: 'Pad 6 Pro' },
      { value: 'PAD_6', label: 'Pad 6' },
      { value: 'PAD_5_PRO', label: 'Pad 5 Pro' },
      { value: 'PAD_5', label: 'Pad 5' },
      { value: 'REDMI_PAD_PRO', label: 'Redmi Pad Pro' },
      { value: 'REDMI_PAD_SE', label: 'Redmi Pad SE' },
      { value: 'REDMI_PAD', label: 'Redmi Pad' },
      { value: 'XIAOMI_TABLET_UNKNOWN', label: 'Autre Xiaomi Pad' },
    ],

    HONOR_TABLET: [
      { value: 'PAD_9', label: 'Pad 9' },
      { value: 'PAD_8', label: 'Pad 8' },
      { value: 'PAD_X9', label: 'Pad X9' },
      { value: 'PAD_X8_PRO', label: 'Pad X8 Pro' },
      { value: 'PAD_X8', label: 'Pad X8' },
      { value: 'PAD_V8_PRO', label: 'Pad V8 Pro' },
      { value: 'MAGIC_PAD_13', label: 'MagicPad 13' },
      { value: 'HONOR_TABLET_UNKNOWN', label: 'Autre Honor Pad' },
    ],

    OPPO_TABLET: [
      { value: 'PAD_AIR_2', label: 'Pad Air 2' },
      { value: 'PAD_AIR', label: 'Pad Air' },
      { value: 'PAD_2', label: 'Pad 2' },
      { value: 'PAD_SE', label: 'Pad SE' },
      { value: 'OPPO_TABLET_UNKNOWN', label: 'Autre Oppo Pad' },
    ],

    REALME_TABLET: [
      { value: 'PAD_2', label: 'Pad 2' },
      { value: 'PAD_X', label: 'Pad X' },
      { value: 'PAD_MINI', label: 'Pad Mini' },
      { value: 'REALME_TABLET_UNKNOWN', label: 'Autre Realme Pad' },
    ],

    NOKIA_TABLET: [
      { value: 'T21', label: 'T21' },
      { value: 'T20', label: 'T20' },
      { value: 'T10', label: 'T10' },
      { value: 'NOKIA_TABLET_UNKNOWN', label: 'Autre Nokia Tablette' },
    ],

    TABLET_OTHER: [
      { value: 'TABLET_GENERIC', label: 'Modèle inconnu' },
    ],

    DELL: [
      { value: 'XPS_15_9530', label: 'XPS 15 (9530)' },
      { value: 'XPS_13_9340', label: 'XPS 13 (9340)' },
      { value: 'XPS_17_9730', label: 'XPS 17 (9730)' },
      { value: 'INSPIRON_15_3520', label: 'Inspiron 15 (3520)' },
      { value: 'INSPIRON_14_5420', label: 'Inspiron 14 (5420)' },
      { value: 'LATITUDE_5540', label: 'Latitude 5540' },
      { value: 'LATITUDE_7440', label: 'Latitude 7440' },
      { value: 'G15_5530', label: 'G15 Gaming (5530)' },
      { value: 'ALIENWARE_M18', label: 'Alienware m18' },
      { value: 'ALIENWARE_X16', label: 'Alienware x16' },
      { value: 'DELL_UNKNOWN', label: 'Autre Dell' },
    ],

    HP: [
      { value: 'SPECTRE_X360_14', label: 'Spectre x360 14"' },
      { value: 'SPECTRE_X360_16', label: 'Spectre x360 16"' },
      { value: 'ENVY_15', label: 'Envy 15' },
      { value: 'ENVY_13', label: 'Envy 13' },
      { value: 'PAVILION_15', label: 'Pavilion 15' },
      { value: 'PAVILION_14', label: 'Pavilion 14' },
      { value: 'ELITEBOOK_840_G10', label: 'EliteBook 840 G10' },
      { value: 'ELITEBOOK_1040_G10', label: 'EliteBook 1040 G10' },
      { value: 'PROBOOK_450_G10', label: 'ProBook 450 G10' },
      { value: 'OMEN_16', label: 'Omen 16' },
      { value: 'VICTUS_16', label: 'Victus 16' },
      { value: 'HP_UNKNOWN', label: 'Autre HP' },
    ],

    LENOVO: [
      { value: 'THINKPAD_X1_CARBON_GEN11', label: 'ThinkPad X1 Carbon Gen 11' },
      { value: 'THINKPAD_X1_YOGA_GEN8', label: 'ThinkPad X1 Yoga Gen 8' },
      { value: 'THINKPAD_T14_GEN4', label: 'ThinkPad T14 Gen 4' },
      { value: 'THINKPAD_P1_GEN6', label: 'ThinkPad P1 Gen 6' },
      { value: 'IDEAPAD_SLIM_5', label: 'IdeaPad Slim 5' },
      { value: 'IDEAPAD_GAMING_3', label: 'IdeaPad Gaming 3' },
      { value: 'YOGA_9I', label: 'Yoga 9i' },
      { value: 'YOGA_7I', label: 'Yoga 7i' },
      { value: 'LEGION_PRO_7I', label: 'Legion Pro 7i' },
      { value: 'LEGION_5_PRO', label: 'Legion 5 Pro' },
      { value: 'LENOVO_UNKNOWN', label: 'Autre Lenovo' },
    ],

    ASUS: [
      { value: 'ZENBOOK_14_OLED', label: 'ZenBook 14 OLED' },
      { value: 'ZENBOOK_PRO_14_DUO', label: 'ZenBook Pro 14 Duo' },
      { value: 'VIVOBOOK_S15', label: 'VivoBook S15' },
      { value: 'VIVOBOOK_PRO_15', label: 'VivoBook Pro 15' },
      { value: 'ROG_ZEPHYRUS_G16', label: 'ROG Zephyrus G16' },
      { value: 'ROG_ZEPHYRUS_M16', label: 'ROG Zephyrus M16' },
      { value: 'ROG_STRIX_G17', label: 'ROG Strix G17' },
      { value: 'TUF_GAMING_A15', label: 'TUF Gaming A15' },
      { value: 'TUF_GAMING_F15', label: 'TUF Gaming F15' },
      { value: 'ASUS_UNKNOWN', label: 'Autre Asus' },
    ],

    ACER: [
      { value: 'SWIFT_3', label: 'Swift 3' },
      { value: 'SWIFT_5', label: 'Swift 5' },
      { value: 'SWIFT_X', label: 'Swift X' },
      { value: 'ASPIRE_5', label: 'Aspire 5' },
      { value: 'ASPIRE_7', label: 'Aspire 7' },
      { value: 'PREDATOR_HELIOS_16', label: 'Predator Helios 16' },
      { value: 'PREDATOR_HELIOS_18', label: 'Predator Helios 18' },
      { value: 'NITRO_5', label: 'Nitro 5' },
      { value: 'NITRO_16', label: 'Nitro 16' },
      { value: 'ACER_UNKNOWN', label: 'Autre Acer' },
    ],

    MSI: [
      { value: 'TITAN_GT77', label: 'Titan GT77' },
      { value: 'RAIDER_GE78', label: 'Raider GE78' },
      { value: 'VECTOR_GP77', label: 'Vector GP77' },
      { value: 'STEALTH_14_STUDIO', label: 'Stealth 14 Studio' },
      { value: 'CYBORG_15', label: 'Cyborg 15' },
      { value: 'KATANA_15', label: 'Katana 15' },
      { value: 'PRESTIGE_16', label: 'Prestige 16' },
      { value: 'MODERN_14', label: 'Modern 14' },
      { value: 'MSI_UNKNOWN', label: 'Autre MSI' },
    ],

    RAZER: [
      { value: 'BLADE_18', label: 'Blade 18' },
      { value: 'BLADE_16', label: 'Blade 16' },
      { value: 'BLADE_15', label: 'Blade 15' },
      { value: 'BLADE_14', label: 'Blade 14' },
      { value: 'BOOK_13', label: 'Book 13' },
      { value: 'RAZER_UNKNOWN', label: 'Autre Razer' },
    ],

    MICROSOFT_LAPTOP: [
      { value: 'SURFACE_LAPTOP_5_15', label: 'Surface Laptop 5 (15")' },
      { value: 'SURFACE_LAPTOP_5_13', label: 'Surface Laptop 5 (13.5")' },
      { value: 'SURFACE_LAPTOP_STUDIO_2', label: 'Surface Laptop Studio 2' },
      { value: 'SURFACE_LAPTOP_GO_3', label: 'Surface Laptop Go 3' },
      { value: 'SURFACE_PRO_9', label: 'Surface Pro 9' },
      { value: 'SURFACE_PRO_8', label: 'Surface Pro 8' },
      { value: 'SURFACE_BOOK_3', label: 'Surface Book 3' },
      { value: 'MICROSOFT_UNKNOWN', label: 'Autre Microsoft Surface' },
    ],
  };

  const currentBrands = selectedDevice ? brandsByDevice[selectedDevice] : [];
  const currentModels = selectedBrand ? modelsByBrand[selectedBrand] : [];

  const handleRepair = () => {
    if (selectedDevice && selectedBrand && selectedModel) {
      router.push(
        `/repair?device=${selectedDevice}&brand=${selectedBrand}&model=${selectedModel}`
      );
    }
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const Dropdown = ({ label, value, options, onChange, name }) => (
    <div className={`relative flex-1 ${openDropdown === name ? 'z-[9999]' : 'z-0'}`}>
      <button
        onClick={() => toggleDropdown(name)}
        className="w-full px-5 py-4 rounded-xl bg-white border-2 border-gray-200 hover:border-[#23994F] text-left font-medium text-gray-700 transition-all duration-300 flex items-center justify-between group hover:shadow-lg"
      >
        <span className={value ? 'text-gray-900' : 'text-gray-400'}>
          {value ? options.find(o => o.value === value)?.label : label}
        </span>
        <ChevronDown
          size={20}
          className={`text-gray-400 group-hover:text-[#23994F] transition-all duration-300 ${
            openDropdown === name ? 'rotate-180' : ''
          }`}
        />
      </button>

      {openDropdown === name && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-gray-200 z-[9999] max-h-48 overflow-y-auto">
          {options.length > 0 ? (
            options.map((option) => (
              <button
                key={option.value}
                onClick={() => {
                  onChange(option.value);
                  setOpenDropdown(null);

                  if (name === 'device') {
                    setSelectedBrand('');
                    setSelectedModel('');
                  } else if (name === 'brand') {
                    setSelectedModel('');
                  }
                }}
                className="w-full text-left px-5 py-4 hover:bg-[#23994F]/5 border-b border-gray-100 last:border-b-0 transition-colors font-medium text-gray-800 hover:text-[#23994F]"
              >
                {option.label}
              </button>
            ))
          ) : (
            <div className="px-5 py-4 text-gray-500 text-sm">
              Sélectionnez d'abord {name === 'brand' ? 'un appareil' : 'une marque'}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <header className="bg-linear-to-r from-[#23994F] to-[#1a7840] text-white pt-12 pb-24 relative shadow-2xl">
      {/* Effet de relief avec des couches ombrées */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 via-transparent to-black/10 pointer-events-none"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.1),transparent_50%)] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* TITRE ANIMÉ */}
        <div className="fade-in mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 leading-tight">
            Trouvez votre téléphone <br /> parfait
          </h1>
          <p className="text-base sm:text-lg text-white/90 font-medium">
            Reconditionnés avec garantie 12 mois - Sauvez jusqu'à 50%
          </p>
        </div>


        <div className={`bg-white rounded-xl sm:rounded-2xl shadow-lg border border-gray-200 p-4 sm:p-6 lg:p-8 fade-in overflow-visible ${openDropdown ? 'relative z-[1000]' : ''}`} style={{ animationDelay: '0.2s' }}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 overflow-visible">

            <div className={`stagger-item ${openDropdown === 'device' ? 'z-[9999] relative' : ''}`} style={{ animationDelay: '0.1s' }}>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Quel appareil ?
              </label>
              <Dropdown
                label="Sélectionnez un appareil"
                value={selectedDevice}
                options={devices}
                onChange={setSelectedDevice}
                name="device"
              />
            </div>


            <div className={`stagger-item ${openDropdown === 'brand' ? 'z-[9999] relative' : ''}`} style={{ animationDelay: '0.2s' }}>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Quelle marque ?
              </label>
              <Dropdown
                label="Sélectionnez une marque"
                value={selectedBrand}
                options={currentBrands}
                onChange={setSelectedBrand}
                name="brand"
              />
            </div>


            <div className={`stagger-item ${openDropdown === 'model' ? 'z-[9999] relative' : ''}`} style={{ animationDelay: '0.3s' }}>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Quel modèle ?
              </label>
              <Dropdown
                label="Sélectionnez un modèle"
                value={selectedModel}
                options={currentModels}
                onChange={setSelectedModel}
                name="model"
              />
            </div>


            <div className="stagger-item flex flex-col justify-end sm:col-span-2 lg:col-span-1" style={{ animationDelay: '0.4s' }}>
              <button
                onClick={handleRepair}
                disabled={!selectedDevice || !selectedBrand || !selectedModel}
                className="w-full min-h-12 sm:h-14 rounded-xl bg-linear-to-r from-[#23994F] to-[#1a7840] text-white font-bold text-base sm:text-lg transition-all duration-300 hover:shadow-lg hover:shadow-[#23994F]/30 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none hover:-translate-y-1 active:translate-y-0 flex items-center justify-center gap-2 sm:gap-3 group"
              >
                <Wrench size={20} className="group-hover:rotate-12 transition-transform" />
                <span className="hidden sm:inline">Je répare</span>
                <span className="sm:hidden">Réparer</span>
              </button>
            </div>
          </div>


          <div className="pt-4 sm:pt-6 border-t border-gray-200 text-center text-xs sm:text-sm text-gray-600 mt-4 sm:mt-6">
            Accès instantané au formulaire de diagnostic et tarif en temps réel
          </div>
        </div>
      </div>
    </header>
  );
}
